import React from 'react'
import { SaveButton } from '../../../../../../common/components/SaveButton'
import { useTreatmentSchemaCreate } from '../../../../TreatmentSchema/hooks/useTreatmentSchemaCreate'
import { useTranslation } from '../../../../../../common/hooks/helper/useTranslation'
import { SaveRounded } from '@mui/icons-material'
import { useTreatmentPanelData } from '../TreatmentPanelProvider'

export const SaveTreatmentButton: React.FC = () => {
  const { treatment } = useTreatmentPanelData()

  const { t } = useTranslation()
  const [createTreatmentSchema, { loading: isCreateLoading }] =
    useTreatmentSchemaCreate({
      variables: {
        schema: {
          treatmentId: treatment.id,
          title: {
            en: t('treatment:protocol.newTitle', { lng: 'en' }),
            hu: t('treatment:protocol.newTitle', { lng: 'hu' }),
          },
          description: {
            en: t('treatment:protocol.noDescription', { lng: 'en' }),
            hu: t('treatment:protocol.noDescription', { lng: 'hu' }),
          },
        },
      },
    })

  return (
    <SaveButton
      size="small"
      color="primary"
      variant="text"
      isSaving={isCreateLoading}
      startIcon={<SaveRounded />}
      onClick={() => createTreatmentSchema()}
      text={t('treatment:saveNewProtocol')}
      sx={{ paddingX: 2, justifyContent: 'flex-start' }}
    />
  )
}
